<template>
    <div>
    <b-field >
        <b-button
        @click="activeModal=true"
        class="is-custom"
        rounded>
        <b-icon icon="envelope" class="m-r-5" size="is-small"></b-icon>
            Me interesa
        </b-button>
    </b-field>

    <b-modal :active.sync="activeModal" scroll="keep">
        <div class="modal-card" style="width:auto">
            
            <div class="modal-card-body has-text-centered">

                <div v-if="!loggedUser" class="columns">
                    <div class="column is-half">
                        <b-field label="Email">
                            <b-input
                            v-model="message.email"
                            icon="envelope"
                            required>
                            </b-input>
                        </b-field>
                    </div>
                    <div class="column is-half">
                        <b-field label="Numero de telefono">
                            <b-input
                            v-model="message.phoneNumber"
                            required
                            ></b-input>
                        </b-field>
                    </div>
                </div>

                <div class="columns is-multiline">
                    <div class="column is-full">
                        <b-field label="Asunto">
                            <b-input
                            v-model="message.title"
                            required>
                            </b-input>
                        </b-field>
                        <b-field label="Mensaje">
                            <b-input
                            required
                            maxlength="400"
                            v-model="message.message"
                            type="textarea">
                            </b-input>
                        </b-field>
                    </div>
                    <div class="column is-full has-text-centered">
                        <VueRecaptcha @verify="verifyCaptcha" sitekey="6LcHavwUAAAAAGnN37OSgSLR7e9XfivBHo7xGRwd"/>
                    </div>
                    <div class="column has-text-centered">   
                        <b-button
                        :disabled="disabbledBtn"
                        :loading="loading"
                        @click="sendMessage"
                        rounded
                        class="is-custom">
                            Enviar mensaje
                            <b-icon class="m-l-5" icon="paper-plane" size="is-small"></b-icon>
                        </b-button>
                    </div>
                </div>
                
            </div>
        </div>
    </b-modal>
    </div> 
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
import { postHandler } from '../../../../services/http';

export default {
    components:{
        VueRecaptcha
    },
    props:{
        classifiedUrl:{
            type:String,
            default:""
        },
        authUser:{
            type:String,
            default:""
        },
        product:{
            type:Object,
            default:new Object({})
        },
    },
    data(){
        return{
            loading:false,
            activeModal:false,
            message:{},
            captchaToken:""
        }
    },
    methods:{
        async sendMessage(){
            var error = {
                resource:"notify",
                text:"Verifica que estan los datos requeridos ingresados y que validaste el captcha"
            }
            var success = {
                resource:"notify",
                text:"Mensaje enviado con exito!!"
            }
            this.loading=true
            this.message["captchaToken"] = this.captchaToken
            this.message["product"] = this.product.id
            var resp = await postHandler(this.classifiedUrl, this.message, {error, success}) 
            this.loading=false
            this.message = {}
            grecaptcha.reset()
        },
        verifyCaptcha(token){
            this.captchaToken = token
            this.disabbledBtn()
        }
    },
    computed:{
        loggedUser(){
            return this.authUser == "True"
        },
        disabbledBtn(){
            var bool = false;
            var bool2;
            if (!this.loggedUser){
                bool = !this.message.email || !this.message.phoneNumber 
            }
            bool2 = !this.message.title || !this.message.message 
            var value = bool || bool2 || !this.captchaToken
            return value

        }
    },
    
}
</script>
<style lang="scss" scoped>
.is-custom{
    background:var(--primary);
    color:var(--text-color)
}
</style>